module.exports = __webpack_public_path__ + "img/logo-blanco-innofarm2.2c8999fd.png";